import { isDefined } from "@omni/utils/helper.utils";

import {
    SearchConfiguration,
    SearchResults
} from "@/redux/modules/value/search/search.types";
import { AlgoliaSearchHit } from "@/services/algolia/types/search.types";
import { getComponentGroup, isGroup, isType } from "@/utils/search/type.utils";
import { SearchComponentGroup } from "@/utils/search/types/searchComponent";
import { PaginationConfiguration } from "@/utils/search/types/searchConfiguration";
import { ResultListState } from "@/utils/search/types/searchState";

type RequestFilter = (
    configuration: SearchConfiguration,
    state: SearchResults
) => SearchConfiguration;

const filterSamePageRequests: RequestFilter = (configuration, state) => {
    const componentGroupsToFilter: Array<SearchComponentGroup> =
        configuration.components
            .map((componentConfiguration) => {
                const paginationConfiguration =
                    componentConfiguration as PaginationConfiguration;
                const { hitsWithInjected, currentPage } =
                    paginationConfiguration;
                if (!isDefined(hitsWithInjected) || !isDefined(currentPage))
                    return;

                const componentConfigurationGroup = getComponentGroup(
                    componentConfiguration.component
                );
                if (!isDefined(componentConfigurationGroup)) return;

                const componentResultListState = state.find(
                    (componentState) =>
                        isType(componentState, "RESULT_LIST") &&
                        isGroup(
                            componentState.component,
                            componentConfigurationGroup
                        )
                ) as ResultListState<AlgoliaSearchHit> | undefined;

                const stateHits = componentResultListState?.hits.length ?? 0;

                return hitsWithInjected <= stateHits && stateHits !== 0
                    ? componentConfigurationGroup
                    : undefined;
            })
            .filter(isDefined);

    const filteredComponents = configuration.components.filter(
        (componentConfiguration) =>
            !componentGroupsToFilter.includes(
                getComponentGroup(componentConfiguration.component)!
            )
    );

    return {
        ...configuration,
        components: filteredComponents
    };
};

const applyRequestFilters: RequestFilter = (configuration, state) =>
    [filterSamePageRequests].reduce(
        (configurationAccumulator, requestFilter) =>
            requestFilter(configurationAccumulator, state),
        configuration
    );

export { applyRequestFilters };
